import type { Ability } from "../../rules";
import type { SpearheadArmy } from "./rules";

export const WaveOfTerror: Ability = { time: "acp" };
export const Ethereal: Ability = { time: "p" };

export const SoulfireRing: Ability = { time: "eat" };
export const CloakedInShadow: Ability = { time: "p" };
export const BeaconOfNagashizzar: Ability = { oncePerBattle: true, time: "yhp" };
export const ShadowSEdge: Ability = { time: "p" };

export const DeathStalkers: Ability = { time: "sfr" };
export const ChorusOfTerror: Ability = { time: "p" };

export const NighthauntSlasherHost: SpearheadArmy = {
  battleTraits:      [WaveOfTerror, Ethereal],
  enhancements:      [SoulfireRing, CloakedInShadow, BeaconOfNagashizzar, ShadowSEdge],
  faction:           "nh",
  regimentAbilities: [DeathStalkers, ChorusOfTerror]
};
